import { getSiteConfig } from '@shared/config';

const { ROUTES, PROTECTED_ROUTES } = getSiteConfig();

type RouteValue = string | ((id: string | number) => string) | ((slug: string) => string);

function getCurrentRouteFromPathname(pathname: string, routes: Record<string, RouteValue>, defaultRoute: string): string {
  const staticRoutes = Object.entries(routes).filter(([, path]) => typeof path === 'string') as [string, string][];
  const sortedRoutes = [...staticRoutes].sort((routeA, routeB) => routeB[1].length - routeA[1].length);
  const matchedRoute = sortedRoutes.find(([, path]) => pathname.includes(path));

  return matchedRoute ? matchedRoute[1] : defaultRoute;
}

const routesCategoryMap = new Map<string, string>();
if (ROUTES.CASINO && ROUTES.SCRATCHCARDS) {
  const { NEW_GAMES, SLOTS, JACKPOT_OVERDRIVE, JACKPOTS_GAMES, TABLE_GAMES, LIVE_DEALER, CATEGORY } = ROUTES.CASINO;
  routesCategoryMap.set('casino.new_games', CATEGORY(NEW_GAMES));
  routesCategoryMap.set('casino.Slots', CATEGORY(SLOTS));
  routesCategoryMap.set('casino.JPOverdrive', CATEGORY(JACKPOT_OVERDRIVE));
  routesCategoryMap.set('casino.jackpots_games', CATEGORY(JACKPOTS_GAMES));
  routesCategoryMap.set('casino.table_games', CATEGORY(TABLE_GAMES));
  routesCategoryMap.set('casino.live_dealer', CATEGORY(LIVE_DEALER));
  routesCategoryMap.set('casino.no-category', ROUTES.CASINO.BROWSE);
  routesCategoryMap.set('scratchcards.discover_page.charity_section.category', ROUTES.SCRATCHCARDS.BROWSE);
  routesCategoryMap.set('scratchcards.discover_page.charity_section.Charity', ROUTES.SCRATCHCARDS.CATEGORIES.CHARITY);
}

export { getCurrentRouteFromPathname, PROTECTED_ROUTES, ROUTES, routesCategoryMap };
